import { IAuthenticatedUser } from 'common/src/types/interfaces';

import { STORAGE_KEYS } from './storageKeys';

export const getUserFromStorage = () => {
  const userData = localStorage.getItem(STORAGE_KEYS.USER);
  if (!userData) return null;

  try {
    const parsed = JSON.parse(userData);
    if ((parsed.expires && Date.now() > parsed.expires) || !parsed.email) {
      localStorage.removeItem(STORAGE_KEYS.USER);
      return null;
    }
    return parsed;
  } catch (error) {
    localStorage.removeItem(STORAGE_KEYS.USER);
    return null;
  }
};

export const setUserInStorage = (user: IAuthenticatedUser) => {
  localStorage.setItem(
    STORAGE_KEYS.USER,
    user
      ? JSON.stringify({
          email: user.email,
          organizationId: user.organizationId,
          expires: Date.now() + 86400000,
        })
      : '',
  );
};

export const removeUserFromStorage = () => {
  localStorage.removeItem(STORAGE_KEYS.USER);
  localStorage.removeItem(STORAGE_KEYS.PROFILE_PICTURE);
};

export const getProfilePictureFromStorage = () => {
  return localStorage.getItem(STORAGE_KEYS.PROFILE_PICTURE);
};

export const setProfilePictureInStorage = (imgSrc) => {
  localStorage.setItem(STORAGE_KEYS.PROFILE_PICTURE, imgSrc);
};

export const setUserReloading = (
  isReloading: 'true' | 'false' = 'true',
): void => {
  sessionStorage.setItem(STORAGE_KEYS.IS_RELOADING, isReloading);
};

export const isUserReloading = (): boolean =>
  sessionStorage.getItem(STORAGE_KEYS.IS_RELOADING) === 'true';
